// extracted by mini-css-extract-plugin
module.exports = {"Stat":"style_Stat__18OHy","Type":"style_Type__cotK0","Value":"style_Value__1ZXGJ","Value_full":"style_Value_full__u4jMS","Action":"style_Action__Om9-L"};